// eslint-disable-next-line
import util from 'util';
import * as actionTypes from '../actionTypes';
import * as PortalApi from '../PortalApi';

import * as coreActions from '../core/actions';
import * as accountActions from '../account/actions';
import * as coreSelectors from '../core/selectors';

import * as serviceSelectors from './selectors';
import * as ServiceApi from './api';
import { ACTIVITY_PAGES } from 'constants/activity.constants';

export const querySmsTasks = ({
  startDate,
  endDate,
  success,
  fail,
  smsVersion,
  useFilterDays = false,
  pageNumber = 1,
  background = false,
}) =>
  function (dispatch, getState) {
    // Background updates are triggered by the Updater
    if (
      background &&
      (serviceSelectors.getUpdatingSmsTasks(getState()) ||
        serviceSelectors.getBackgroundUpdateSmsTasks(getState()))
    ) {
      return;
    }
    if (background) {
      dispatch(setBackgroundUpdatingSmsTasks(true));
    } else {
      dispatch(setUpdatingSmsTasks(true));
    }
    let messages = serviceSelectors.getLast20Messages(getState());
    if (startDate) {
      startDate = new Date(startDate);
    } else {
      const oldestSmsTask = messages?.smsTasks?.sort((a,b)=> new Date(a.lastMessage) - new Date(b.lastMessage));
      startDate = new Date();
      // Filter days is the default time range used to query for updates
      // Use Filter days when a startDate is not provided or if there are no smsTasks currently loaded
      if(useFilterDays || !oldestSmsTask || !oldestSmsTask.length){
        startDate.setDate(
          startDate.getDate() - serviceSelectors.getFilterDays(getState())
        );
      }
      // We try to use the time range of all the smsTasks which are currently loaded
      else{
        startDate = new Date(oldestSmsTask[0].lastMessage) 
      }
    }
    startDate.setHours(0, 0, 0, 0);
    if (endDate) {
      endDate = new Date(endDate);
      endDate.setHours(23, 59, 59, 999);
    }

    ServiceApi.querySmsTasks(
      (response) => {
        if (response?.smsTasks && response?.smsTasks?.length) {
          // Pass in empty pureChats and userMessages to not change them
          // Maintaining the same versions for chat, user & sms versions
          processMessages(dispatch, getState, {
            chatVersion: messages?.chatVersion ?? "0",
            pureChats: [],
            smsTaskVersion: response.version,
            smsTasks: response.smsTasks,
            userMessages: [],
            userVersion: messages?.userVersion ?? "0",
          });
        }
        if (typeof success === "function") {
          success(response);
        }
        dispatch(setUpdatingSmsTasks(false));
        dispatch(setBackgroundUpdatingSmsTasks(false));
      },
      (error, status, content) => {
        PortalApi.defaultErrorHandler(error, status, content);
        if (typeof fail === "function") {
          fail();
        }
        dispatch(setUpdatingSmsTasks(false));
        dispatch(setBackgroundUpdatingSmsTasks(false));
      },
      startDate,
      endDate,
      pageNumber,
      smsVersion ?? messages?.smsTaskVersion ?? "0"
    );
  };
/*
 * Refresh the current messages lists.  
 */
export const updateMessages = () => {
  return function(dispatch, getState) {
    /* Only run one a time */
    if (serviceSelectors.getUpdatingMessages(getState())) {
      dispatch(setUpdateMessagesAgain(true));
      return;
    }
    dispatch(setUpdatingMessages(true));
    dispatch(setUpdateMessagesAgain(false));

    let accountId = serviceSelectors.getFilterAccountId(getState());
    let locationId = serviceSelectors.getFilterLocationId(getState());
    let messages = serviceSelectors.getMessages(getState());

    /* Figure out the start date */
    let startDate = new Date();
    startDate.setDate(startDate.getDate() -
                      serviceSelectors.getFilterDays(getState()));

    /* We can do incremental updates as long as the cached has 
       the same or earlier start date than the current selection */
    let userVersion = 0;
    let smsTaskVersion = 0;
    let accountVersion = 0;
    let locationVersion = 0;
    if (messages.startTime) {
      let d = new Date(messages.startTime);
      if (d < startDate) {
        userVersion = messages.userVersion || 0;
        smsTaskVersion = messages.smsTaskVersion || 0;
        /* For account and location, the accountId and locationId must also
           be the same  */
        if (accountId && String(accountId) === messages.accountId) {
          accountVersion = messages.accountVersion || 0;
        }
        if (locationId && String(locationId) === messages.locationId) {
          locationVersion = messages.locationVersion || 0;
        }
      }
    }

    /* Get the messages */
    ServiceApi.queryMessages((response) => {
      processMessages(dispatch, getState, response);
      dispatch(refreshUnread());
      dispatch(refreshUnreadChats());
      dispatch(setUpdatingMessages(false));
    }, (error, status, content) => {
      PortalApi.defaultErrorHandler(error, status, content);
      dispatch(setUpdatingMessages(false));
    }, startDate, userVersion, smsTaskVersion, accountId, accountVersion, locationId, locationVersion);
  }
}

/*
 * Generate a PDF Report of activity
 */
export const generatePdfReport = (filterType, messageId, startDate, endDate,filterText,selectedMessages,matchWord, messageGroupId=undefined) => {
  return function(dispatch, getState) {

    let accountId = serviceSelectors.getFilterAccountId(getState());
    let locationId = serviceSelectors.getFilterLocationId(getState());
    let now = new Date();
    let offset = -1 * now.getTimezoneOffset();
                      
    let accountVersion = 0;

    /* Get the pdf */
    ServiceApi.queryActvityReport((response) => {
      var link = document.createElement('a');
      link.href = 'data:application/pdf;base64,' + response;
      link.download = "Report.pdf";
      link.click();
      dispatch(setPdfContent(Buffer.from(response, 'base64')));
      dispatch(setUpdatingMessages(false));
    }, (error, status, content) => {
      PortalApi.defaultErrorHandler(error, status, content);
      dispatch(setUpdatingMessages(false));
    }, startDate, endDate, accountId, accountVersion, locationId, filterType, messageId,filterText,selectedMessages,matchWord, offset, messageGroupId);
  }
}

/*
 * Generate a PDF Report of activity
 */
export const generateCsvReport = (filterType, messageId, startDate, endDate, filterText, messageIds, page=ACTIVITY_PAGES.ACTIVITY) => {
  return function(dispatch, getState) {

    let accountId = serviceSelectors.getFilterAccountId(getState());
    let locationId = serviceSelectors.getFilterLocationId(getState());
                      
    let accountVersion = 0;

    let now = new Date();
    let offset = -1 * now.getTimezoneOffset();

    if(page===ACTIVITY_PAGES.ACTIVITY){
    /* Get the csv */
    ServiceApi.queryCsvActvityReport((response) => {
      const blob = new Blob([response], { type: 'text/csv' });
      const url = URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = url;
      link.download = "ActivityReport.csv";
      link.click();
      dispatch(setPdfContent(Buffer.from(response, 'base64')));
      URL.revokeObjectURL(url);
      dispatch(setUpdatingMessages(false));
    }, (error, status, content) => {
      PortalApi.defaultErrorHandler(error, status, content);
      dispatch(setUpdatingMessages(false));
    }, startDate, endDate, accountId, accountVersion, locationId, filterType, messageId, offset, filterText, messageIds);
    }
    else{
      ServiceApi.queryCsvChatReport((response) => {
        const blob = new Blob([response], { type: 'text/csv' });
        const url = URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = url;
        link.download = "ChatReport.csv";
        link.click();
        dispatch(setPdfContent(Buffer.from(response, 'base64')));
        URL.revokeObjectURL(url);
        dispatch(setUpdatingMessages(false));
      }, (error, status, content) => {
        PortalApi.defaultErrorHandler(error, status, content);
        dispatch(setUpdatingMessages(false));
      }, startDate, endDate, accountId, accountVersion, locationId, filterType, messageId, offset);
    }
  }
}

/*
 * Generate a PDF Report of activity
 */
export const generateCsvSmsReport = (startTime, endTime) => {
  return function (dispatch, getState) {
    let now = new Date();
    let offset = -1 * now.getTimezoneOffset();

    ServiceApi.queryCsvSmsReport(
      (response) => {
        const blob = new Blob([response], { type: "text/csv" });
        const url = URL.createObjectURL(blob);
        var link = document.createElement("a");
        link.href = url;
        link.download = "SmsReport.csv";
        link.click();
        dispatch(setPdfContent(Buffer.from(response, "base64")));
        URL.revokeObjectURL(url);
        dispatch(setUpdatingMessages(false));
      },
      (error, status, content) => {
        PortalApi.defaultErrorHandler(error, status, content);
        dispatch(setUpdatingMessages(false));
      },
      {
        startTime,
        endTime,
        offset
      }
    );
  };
};

/*
 * Generate a PDF Report of activity
 */
export const generateChatExport = (chatId) => {
  return function(dispatch, getState) {
    ServiceApi.generateChatExport((response) => {
      var link = document.createElement('a');
      link.href = 'data:application/pdf;base64,' + response;
      link.download = "ChatExport.pdf";
      link.click();
      dispatch(setPdfContent(Buffer.from(response, 'base64')));
      dispatch(setUpdatingMessages(false));
    }, (error, status, content) => {
      PortalApi.defaultErrorHandler(error, status, content);
      dispatch(setUpdatingMessages(false));
    }, chatId);
  }
}

export const downloadVoiceMail = (voicemailId) => {
  return function(dispatch, getState) {
    ServiceApi.getDownloadUrl((result) => {
      fetch(result.downloadUrl).then(response => {
        var reader = response.body.getReader();
        var blobObj = []
          let pump = () => reader.read().then(({value, done}) => {
            if(value !== undefined){
              value.forEach(item => {
                blobObj.push(item);
              })
            }
            if(!done){
              pump()
            }else{
              var u8 = new Uint8Array(blobObj);
              var b64 = Buffer.from(u8).toString('base64');
              var link = document.createElement('a');
              link.href = 'data:@file/mpeg;base64,' + b64;
              link.download = voicemailId + ".mp3";
              link.click();
            }
          })
          pump()
        })
    }, (error) => {
      console.log(error);
    }, voicemailId)
  }
}
/**
 * By default fetching messages is throttled to occur only once every 60 seconds. (To limit constant message fetching due to websocket updates)
 * force = Force Refresh messages. Overrides the 60second throttle to fetch new messages
 * scrollEnd = A parameter indicating we want to load more rows for the given date range
 * start = start time to load messages
 * end = end time to load messages
 * compelted = A callback when messages are fetched
 */
export const getAllMessages = ({
  force,
  scrollEnd,
  start,
  end,
  completed,
  fromChatPage = false
} = {}) => {
  return function(dispatch, getState) {
    if(fromChatPage){
      dispatch(getPureChats({
      force,
      scrollEnd,
      completed,
      }))
      return;
    }
    // console.log('Get all messages input', {
    //   force,
    //   scrollEnd,
    //   start,
    //   end,
    //   messageLoaded: serviceSelectors.getMessagesLoaded(getState())
    // })
    let accountId = serviceSelectors.getFilterAccountId(getState());
    let locationId = serviceSelectors.getFilterLocationId(getState());
    let messages = serviceSelectors.getLast20Messages(getState());
    // If start is provided make the hours at 12:00 am
    if(start){
      start = new Date(start);
      start.setHours(0,0,0,0);
    }
    // If end is provided make the hours at 11:59 pm
    if(end){
      end = new Date(end);
      end.setHours(23,59,59,999);
    }

    let userVersion = messages.userVersion || 0;
    let chatVersion = messages.chatVersion || 0;
    if(scrollEnd){
      chatVersion = 0;
    }

    let pageNumber = 1;

    if(messages?.pureChats?.length > 0){
      pageNumber = parseInt(messages?.pureChats?.length/100) + 1;
    }

    let startDate = new Date();
    let endDate = new Date();
    startDate.setDate(startDate.getDate() -
                      serviceSelectors.getFilterDays(getState()));
    // Atleast one non chat message is loaded (Activity Page messages) and end of scroll has been reached
    if(messages.userMessages.find(m => m.messageType !== 'CHAT') && scrollEnd){
      let lastMessage = messages.userMessages.filter(m => m.messageType !== 'CHAT' && m.messageType !== 'SMS').sort((a, b)  => (new Date(a.taken || a.updateDate || a.updated).getTime() - new Date(b.taken || b.updateDate || b.updated).getTime()))[0];
      if(start){
        startDate = start;
      }else {
        startDate.setDate(new Date(lastMessage.taken).getDate() - 5);
      } 
      // Since activity is fetched and sorted by create date of message deliveries from newest to oldest
      // use the end date provided only if it is older than the oldest we have already loaded
      if(end && new Date(end) < new Date(lastMessage.taken)){
        endDate = end;
      }else {
        endDate = lastMessage.taken;
      }
      userVersion = 0;
    }
    // When scrollEnd is false and we have valid dates provided for start and end
    else if(!scrollEnd && (start || end)){
      if(start){
        startDate = start;
      }
      if(end){
        endDate = end;
      }
      userVersion = 0;
    }
    if(force && new Date(startDate) < new Date(endDate)){
      dispatch(setShowLoading(true));
      ServiceApi.getAllMessages((result) => {
        if(typeof(completed) === 'function'){
          completed(result);
        }
        dispatch(setShowLoading(false));
        dispatch(setMessagesLoaded(new Date().getTime()));
        if(parseInt(messages.userVersion) > parseInt(result.userVersion)){
          processMessages(dispatch, getState, {...result, userVersion: messages.userVersion});
        } else {
          processMessages(dispatch, getState, result);
        }
      }, (error) => {
        console.log(error)
      }, startDate, endDate, userVersion, chatVersion, pageNumber, null, accountId, null, locationId, null, true)
    }
    // Usually called by the websocket updater
    if(serviceSelectors.getMessagesLoaded(getState()) === null || (serviceSelectors.getMessagesLoaded(getState()) !== null && (serviceSelectors.getMessagesLoaded(getState()) + (60*1000)) < new Date().getTime() )){
      dispatch(setShowLoading(true));
      ServiceApi.getAllMessages((result) => {
        if(typeof(completed) === 'function'){
          completed(result);
        }
        dispatch(setShowLoading(false));
        dispatch(setMessagesLoaded(new Date().getTime()));
        processMessages(dispatch, getState, result);
      }, (error) => {
        console.log(error)
      }, startDate, endDate, userVersion, chatVersion, pageNumber, null, accountId, null, locationId, null, true)
    }
  }
}

/**
 * By default fetching messages is throttled to occur only once every 60 seconds. (To limit constant message fetching due to websocket updates)
 * force = Force Refresh messages. Overrides the 60second throttle to fetch new messages
 * scrollEnd = A parameter indicating we want to load more rows for the given date range
 * start = start time to load messages
 * end = end time to load messages
 * compelted = A callback when messages are fetched
 */
export const getPureChats = ({
  force,
  scrollEnd = false,
  completed,
  chatVersion: inputChatVesion = null
} = {}) => {
  return function(dispatch, getState) {
    const pageSize = 100;
    const messages = serviceSelectors.getLast20Messages(getState());
    // Default of 30Days worth of pure chats
    const startDate = new Date(serviceSelectors.getPureChatsStartTime(getState()));
    const endDate = new Date(serviceSelectors.getPureChatsEndTime(getState()));
    startDate.setHours(0,0,0,0);
    endDate.setHours(23,59,59,999);
    const chatVersion = inputChatVesion ?? (messages.chatVersion || 0);
    let pageNumber = 1;
    // We want to load more pureChats for the same date range ideally
    if(scrollEnd) {
      // Figure out the page number we need
      if(messages?.pureChats?.length > 0){
        pageNumber = parseInt(messages?.pureChats?.length/pageSize) + 1;
      }
    }
    // console.log("Final API Params:", {startDate, endDate, pageNumber, chatVersion} )
    if(force && new Date(startDate) < new Date(endDate)){
      dispatch(setShowLoading(true));
      ServiceApi.getPureChats((result) => {
        if(typeof(completed) === 'function'){
          completed({...result, pageNumber});
        }
        dispatch(setShowLoading(false));
        dispatch(setMessagesLoaded(new Date().getTime()));
        if(parseInt(messages.userVersion) > parseInt(result.userVersion)){
          processMessages(dispatch, getState, {...result, userVersion: messages.userVersion});
        } else {
          processMessages(dispatch, getState, result);
        }
      }, (error) => {
        console.log(error)
      }, startDate, endDate, pageNumber, chatVersion)
    }
    // Usually called by the websocket updater
    else if(serviceSelectors.getMessagesLoaded(getState()) === null || (serviceSelectors.getMessagesLoaded(getState()) !== null && (serviceSelectors.getMessagesLoaded(getState()) + (60*1000)) < new Date().getTime() )){
      dispatch(setShowLoading(true));
      ServiceApi.getPureChats((result) => {
        if(typeof(completed) === 'function'){
          completed(result);
        }
        dispatch(setShowLoading(false));
        dispatch(setMessagesLoaded(new Date().getTime()));
        processMessages(dispatch, getState, result);
      }, (error) => {
        console.log(error)
      }, startDate, endDate, pageNumber, chatVersion)
    }
  }
}

/* Update the unread count.  It's always based on the user message list */
export const refreshUnread = () => {
  return function(dispatch, getState) {
    let count = 0;
    serviceSelectors.getMessages(getState()).userMessages.forEach(message=> {
      if (!message.read) {
        count++;
      }
    });
    dispatch(setUnreadMessageCount(count));
  }
}

/* Update the unread count for the chats */
export const refreshUnreadChats = () => {
  return function(dispatch, getState) {
    let count = 0;
    serviceSelectors.getMessages(getState()).smsTasks.forEach(chat=> {
      count += chat.unread;
    });
    dispatch(setUnreadChatCount(count));
  }
}


/* Process a message update from updateMessages.   */
export const processMessages = (dispatch, getState, response) => {
  let messages = serviceSelectors.getLast20Messages(getState());

  
  /* If there is an open message, see if should be updated */
  let openMessage = serviceSelectors.getMessage(getState());
  if (openMessage) {
    if (!checkMessageUpdate(dispatch, openMessage, response.userMessages)) {
      if (!checkMessageUpdate(dispatch, openMessage, response.locationMessages)) {
        checkMessageUpdate(dispatch, openMessage, [...response.userMessages, ...response.pureChats]);
      }
    }
  }

  let currentPureChatVersion = messages.chatVersion || "0";
  if(parseInt(currentPureChatVersion) > parseInt(response.chatVersion)){
    response.chatVersion = currentPureChatVersion;
  }

  // Incrementally update the userMessages
  response.userMessages = mergeMessages([...messages.userMessages], response.userMessages);
  // response.userMessages = mergeMessages([...response.userMessages], response.pureChats);
  // Incrementally update the pure chat
  response.pureChats = mergeMessages([...messages.pureChats], response.pureChats);
  /* Merge messages and SMS tasks */
  if (messages.smsTasks) {
    response.smsTasks = mergeSmsTasks(messages.smsTasks.map(task => ({ ...task, messages: [...task.messages]})),
                                      response.smsTasks);
  }

  /* If there is an open smsTask, see if should be updated */
  if (response.smsTasks) {
    let smsTaskIndex = response.smsTasks.findIndex(t => t.taskId === serviceSelectors.getSmsTask(getState()).taskId);
    if (smsTaskIndex >= 0) {
      dispatch(setSmsTask(response.smsTasks[smsTaskIndex]));
    } else {
      dispatch(setSmsTask({ messages: [] }));
    }
  }
  

  /* Keep the old account and location messages only if the accountId and locationId has not change */
  if (response.accountMessages && response.accountId === messages.accountId) {
    response.accountMessages = mergeMessages([...messages.accountMessages], response.accountMessages);
  }
  if (response.locationMessages && response.locationId === messages.locationId) {
    response.locationMessages = mergeMessages([...messages.locationMessages], response.locationMessages);
  }

  dispatch(setLast20Messages(response));

}

/* Check if the open message has been updated with a newer version */
function checkMessageUpdate(dispatch, openMessage, messages) {
  if (!messages) {
    return(false);
  }
  let i = messages.findIndex(message => message.messageId ===
    openMessage.messageId && message.version > openMessage.version)
  if (i >= 0) {
    dispatch(setMessage(messages[i]));
    return(true);
  }
  return(false);
}

function mergeMessages(messages, incrementalMessages) {
  if (!messages) {
    return([]);
  }
  
  if (!incrementalMessages || incrementalMessages.length === 0) {
    return(messages);
  }
  
  incrementalMessages.forEach((message) => {
    /* Replace an existing or push a new one */
    let oldRecordIndex = messages.findIndex((oldMessage) =>
      oldMessage.messageId === message.messageId);
    if (oldRecordIndex >= 0) {
      /* Carry over the hold flag used to retain the message on the
         screen even if it no longer matches the filtering. */
      let hold = messages[oldRecordIndex].hold || false;
      messages[oldRecordIndex] = message;
      messages[oldRecordIndex].hold = hold;
    } else {
      messages.push(message);
    }
  });

  /* Default sort from newest to oldest */
  messages.sort((a,b) => b.messageId - a.messageId);
  return(messages);
}


/*
 * Clear any hold flags in the message list.  Hold flags are used to
 * prevent messages from vanishing immediately in situations like
 * reading it while on the unread only list.  Clicking query or
 * changing any filter options runs this.
 */
export const clearHolds = () => {
  return function(dispatch, getState) {
    let messages = { ...serviceSelectors.getMessages(getState()) };
    
    if (messages.userMessages) {
      messages.userMessages = messages.userMessages.map(message=>({...message, hold: false}));
    }
    if (messages.locationMessages) {
      messages.locationMessages = messages.locationMessages.map(message=>({...message, hold: false}));
    }
    if (messages.accountMessages) {
      messages.accountMessages = messages.accountMessages.map(message=>({...message, hold: false}));
    }
    dispatch(setMessages(messages));
  }
}

/*
 * Merge the SMS task updated with the current list
 */
export const mergeSmsTasks = (smsTasks, incrementalSmsTasks) => {
  incrementalSmsTasks.forEach(newSmsTask => {
    /* See if the task is already there */
    let taskIndex = smsTasks.findIndex(task => task.taskId === newSmsTask.taskId);
    
    /* Add it if needed.  We'll re-sort after all the updates */
    if (taskIndex < 0) {
      smsTasks.push(newSmsTask);
      taskIndex = smsTasks.length - 1;
    } else {
      /* Otherwise update the record but keep the original list */
      let messages = smsTasks[taskIndex].messages;
      smsTasks[taskIndex] = { ...newSmsTask, messages };
    }
    
    /* Add or update messages */
    newSmsTask.messages.forEach(newMessage => {
      let messageIndex = smsTasks[taskIndex].messages.findIndex(message => message.messageId ===
        newMessage.messageId);
      if (messageIndex < 0) {
        smsTasks[taskIndex].messages.push(newMessage);
      } else {
        smsTasks[taskIndex].messages[messageIndex] = newMessage;
      }
    });
    
    /* Sort message list newest last */
    smsTasks[taskIndex].messages.sort((a,b) => new Date(a.taken).getTime() - 
                                             new Date(b.taken).getTime());
  });
  
  /* Sort the task list newest first */
  smsTasks.sort((a,b) => new Date(b.taken).getTime() - 
                       new Date(a.taken).getTime());
  return(smsTasks);
}  

/* */
export const setLast20Messages = (last20Messages) => ({
  type : actionTypes.SET_LAST_20_MESSAGES,
  payload : { last20Messages }
});

/* */
export const setFilters = (filters) => ({
  type : actionTypes.SET_FILTERS,
  payload : { filters }
});

/* */
export const setChatFilters = (chatFilters) => ({
  type : actionTypes.SET_CHAT_FILTERS,
  payload : { chatFilters }
});
/* */
export const setShowFilterDialog = (showFilterDialog) => ({
  type : actionTypes.SET_SHOW_FILTER_DIALOG,
  payload : { showFilterDialog }
});


/* */
export const setFilterListText = (filterListText) => ({
  type : actionTypes.SET_FILTER_LIST_TEXT,
  payload : { filterListText }
});

/* */
export const setChatFilterListText = (chatFilterListText) => ({
  type : actionTypes.SET_CHAT_FILTER_LIST_TEXT,
  payload : { chatFilterListText }
});


/*
 * Update the filters
 */
export const updateFilters = (filters, page=ACTIVITY_PAGES.ACTIVITY) => {
  return function(dispatch, getState) {
    if(page===ACTIVITY_PAGES.ACTIVITY){
      dispatch(setFilters(filters));    
    }
    else{
      dispatch(setChatFilters(filters));
    }
    dispatch(clearHolds());
    
    /* See if nothing is checked */
    let none = true;
    Object.keys(filters).forEach(filterKey => {
      if (filters[filterKey].active) {
        none = false;
      }
    });
    if (none) {
      if(page===ACTIVITY_PAGES.ACTIVITY){
        dispatch(setFilterListText('No Filters'));
      }
      else{
        dispatch(setChatFilterListText('No Filters'));
      }
      return;
    }

    /* Otherwise list them */
    let list = '';
    Object.keys(filters).forEach(filterKey => {
      if (filters[filterKey].active) {
        if (list.length > 0) {
          list+=', ';
        }
        list += filters[filterKey].label;
      }
    });
    if(page===ACTIVITY_PAGES.ACTIVITY){
      dispatch(setFilterListText(list));
    }
    else{
      dispatch(setChatFilterListText(list))
    }
  }
}

/* */
export const setMessagesLoaded = (messagesLoaded) => ({
  type : actionTypes.SET_MESSAGES_LOADED,
  payload : { messagesLoaded }
});

export const setShowLoading = (showLoading) => ({
  type : actionTypes.SET_SHOW_LOADING,
  payload : { showLoading }
});

/* */
export const setFilterType = (filterType) => ({
  type : actionTypes.SET_FILTER_TYPE,
  payload : { filterType }
});

/* */
export const setFilterDays = (filterDays) => ({
  type : actionTypes.SET_FILTER_DAYS,
  payload : { filterDays }
});

/* */
export const setFilterSearch = (filterSearch) => ({
  type : actionTypes.SET_FILTER_SEARCH,
  payload : { filterSearch }
});

/* */
export const setFilterAccountId = (filterAccountId) => ({
  type : actionTypes.SET_FILTER_ACCOUNT_ID,
  payload : { filterAccountId }
});

/* */
export const setFilterLocationId = (filterLocationId) => ({
  type : actionTypes.SET_FILTER_LOCATION_ID,
  payload : { filterLocationId }
});

/* */
export const setFilterAccounts = (filterAccounts) => ({
  type : actionTypes.SET_FILTER_ACCOUNTS,
  payload : { filterAccounts }
});


/*
 * Called after user update to update the searchable accounts and locations
 */
export const updateFilterAccounts = (filters) => {
  return function(dispatch, getState) {
    let roles = coreSelectors.getUser(getState()).userAccountRoles;

    let accounts = [];
    let locations = [];
    roles.forEach(role => {
      if (role.userRoleKey === 'GLOBALADMIN') {      
        if (accounts.findIndex(account => account.accountId === role.accountId) < 0) {
          accounts.push({ accountId : role.accountId,
                          accountName : role.accountName,
                          accountNumber : role.accountNumber });
        }
        if (locations.findIndex(location => location.locationId === role.locationId) < 0) {
          locations.push({ locationId : role.locationId,
                          locationName : role.accountNumber + ' ' + role.accountName +
                                         ' / ' + role.locationName});
          
        }
      }
      if (role.userRoleKey === 'LOCATIONADMIN') {
        if (locations.findIndex(location => location.locationId === role.locationId) < 0) {
          locations.push({ locationId : role.locationId,
                           locationName : role.accountNumber + ' ' + role.accountName +
                                          ' / ' + role.locationName});
          
        }
      }
    });

    dispatch(setFilterAccounts(accounts));
    dispatch(setFilterLocations(locations));

    let accountIndex = accounts.findIndex(account => account.accountId ===
      serviceSelectors.getFilterAccountId(getState()));
    if (accountIndex < 0) {
      if (accounts.length > 0) {
        dispatch(setFilterAccountId(accounts[0].accountId));
        accountIndex=0;
      } else {
        dispatch(setFilterAccountId(''));
      }
    }
    let locationIndex = locations.findIndex(location => location.locationId ===
      serviceSelectors.getFilterLocationId(getState()));
    if (locationIndex < 0) {
      if (locations.length > 0) {
        dispatch(setFilterLocationId(locations[0].locationId));
      } else {
        dispatch(setFilterLocationId(''));
      }
    }
  }
}

export const openActivityDetail = (message) => {
  return function(dispatch, getState) {
    // if (!message.read &&
    //     message.deliveryId &&
    //     message.userId === coreSelectors.getUser(getState()).userId) {
    //   dispatch(markMessageRead(message.messageId));
    // }
    if(message.messageType === 'CHAT'){
      dispatch(markPurechatRead(message.chatId, 'N'));
    } else {
      dispatch(markMessageRead(message.messageId));
    }
    dispatch(setMessage(message));
    dispatch(setActivityDetailOpen(true));
  }
}

export const openContact = (contact) => {
  return function(dispatch, getState) {
    dispatch(setContact(contact));
    dispatch(setContactOpen(true));
    let addContactLink = serviceSelectors.getAddContactLink(getState());
    dispatch(setContactChanged(false));            
    if (addContactLink) {
      dispatch(setContactChanged(true));
      if (addContactLink.type === 'EMAIL') { 
        let searchText = addContactLink.value.toUpperCase();
        let emailMatches = contact.contactMethods.filter(method =>
          method.email && method.email.toUpperCase().includes(searchText)).length;
        if (emailMatches === 0) {
          contact.contactMethods.push({ contactMethodId: 'N00002',
                                        changed: true,
                                        contactMethodType : 'EMAIL',
                                        email: addContactLink.value || '',
                                        description: 'Office'});
          dispatch(setContactChanged(true)); 
        }
      }
      if (addContactLink.type === 'PHONE') {
        let phoneSearch = addContactLink.value.replace(/[()-\s]/g, '');
        let numberMatches = contact.contactMethods.filter(method =>
          method.phoneNumber && method.phoneNumber.replace(/[()-\s]/g, '')
                                      .includes(phoneSearch)).length;
        if (numberMatches === 0) {
          contact.contactMethods.push({ contactMethodId: 'N00001',
                                        changed: true,
                                        contactMethodType : 'PHONE',
                                        phoneNumber: addContactLink.value || '',
                                        phoneExtension: '',
                                        description: 'Mobile'});
          dispatch(setContactChanged(true)); 
        }
      }
    }
  }
}

/* 
 * Open the contact editor with a new contact optionally prefilling with the given 
 * name, phone number, or email
 */
export const newContact = (number, email, name) => {
  return function(dispatch, getState) {
    let firstName = '';
    let lastName = '';
    if (typeof(name) === 'string') {
      let result = name.match(/^\s*(\S+)\s*(.*)$/);
      firstName = result[1];
      lastName = result[2];
    }
    let contact = { contactId: 'new',
                    firstName,
                    lastName,
                    title: '',
                    business: '',
                    changed: true,
                    contactMethods : []};
    contact.contactMethods.push({ contactMethodId: 'N00001',
                                  changed: true,
                                  contactMethodType : 'PHONE',
                                  phoneNumber: number || '',
                                  phoneExtension: '',
                                  description: 'Mobile'});
    contact.contactMethods.push({ contactMethodId: 'N00002',
                                  changed: true,
                                  contactMethodType : 'EMAIL',
                                  email: email || '',
                                  description: 'Office'});
    dispatch(setContact(contact));
    dispatch(setContactOpen(true));
    dispatch(setContactChanged(false));
    // dispatch(updateMessages())
  }
}


/*
 * Save the contact in the editor
 */
export const saveContact = (contact) => {
  return function(dispatch, getState) {
    /* Create or update the contact if changed and then call 
       saveContactMethods with the contactId */
    if (contact.changed) {
      if (contact.contactId === 'new') {
        ServiceApi.addContact((response) => {
          contact.contactId = response.contact.contactId;
          dispatch(setContact(contact));
          dispatch(coreActions.updateUser());
          dispatch(saveContactMethods(contact));
        }, null, contact);
      } else {
        dispatch(saveContactMethods(contact));
        ServiceApi.updateContact((contact) => {                
          dispatch(saveContactMethods(contact));   
        }, null, contact);
      }
    } else {
      dispatch(saveContactMethods(contact));
    }
    dispatch(setAddContactLink(undefined));
  }
}

/*
 * Save the new/changed contact methods in the editor.  this is called
 * by saveContact
 */
export const saveContactMethods = (contact) => {
  return function(dispatch, getState) {
    let contactMethods = contact.contactMethods || [];
    
    contactMethods.forEach(contactMethod => {
      if (contactMethod.changed) {
        if (contactMethod.deleted) {
          ServiceApi.deleteContactMethod(() => {
            dispatch(coreActions.updateUser());            
          }, null, contactMethod);
        } else {
          if (typeof(contactMethod.contactMethodId) === 'string' &&
              contactMethod.contactMethodId.startsWith('N')) {
            ServiceApi.addContactMethod(() => {
              dispatch(coreActions.updateUser());            
            }, null, {...contactMethod, contactId : contact.contactId});
          } else {
            ServiceApi.updateContactMethod(() => {
              dispatch(coreActions.updateUser());
            }, null, contactMethod);
          }
        }
      }
    });

  }
}

export const deleteContact = (contactId) => {
  return function(dispatch, getState) {
    ServiceApi.deleteContact(() => {
      dispatch(coreActions.updateUser());
      // dispatch(updateMessages())
    }, null, contactId);
  }
}

/*
 * Locally update and hold any instance of a message.  This is done
 * before sending to the backend to give a faster response
 */
function localUpdate(dispatch, getState, messageId, change) {
  let messages = { ...serviceSelectors.getMessages(getState()) };
  
  if (messages.userMessages) {
    let messageIndex = messages.userMessages.findIndex(message => message.messageId === messageId);
    if (messageIndex >= 0) {
      let newMessageList = [ ...messages.userMessages ];
      newMessageList[messageIndex] = change(messages.userMessages[messageIndex]);
      newMessageList[messageIndex].hold = true;    
      messages.userMessages = newMessageList;
    }
  }
  
  if (messages.locationMessages) {
    let messageIndex = messages.locationMessages.findIndex(message => message.messageId === messageId);
    if (messageIndex >= 0) {
      let newMessageList = [ ...messages.locationMessages ];
      newMessageList[messageIndex] = change(messages.locationMessages[messageIndex]);
      newMessageList[messageIndex].hold = true;    
      messages.locationMessages = newMessageList;
    }
  }

  if (messages.accountMessages) {
    let messageIndex = messages.accountMessages.findIndex(message => message.messageId === messageId);
    if (messageIndex >= 0) {
      let newMessageList = [ ...messages.accountMessages ];
      newMessageList[messageIndex] = change(messages.accountMessages[messageIndex]);
      newMessageList[messageIndex].hold = true;    
      messages.accountMessages = newMessageList;
    }
  }

  dispatch(setMessages(messages));

  let openMessage = serviceSelectors.getMessage(getState());
  if (openMessage.messageId === messageId) {
    let newOpenMessage = change(openMessage);
    newOpenMessage.hold = true;
    dispatch(setMessage(newOpenMessage));
  }
}

/*
 * Mark a message read for the current user
 */
export const markMessageRead = (messageId) => {
  return function(dispatch, getState) {
    let date = new Date();
    localUpdate(dispatch, getState, messageId, message => ({...message, read : date}));
    ServiceApi.readMessage(() => {
      // dispatch(updateMessages());
      dispatch(getAllMessages({ force: true }));
    }, null, messageId);
  }
}

/*
 * Mark a chat as read
 */
export const markChatRead = (taskId) => {
  return function(dispatch, getState) {
    ServiceApi.readChat(() => {
      dispatch(querySmsTasks({ background: true }));
    }, null, taskId);
  }
}

/*
 * Optimistically update SMS task archive status in local state
 */
export const updateSmsTaskArchiveStatus = (taskId, archived) => {
  return {
    type: actionTypes.UPDATE_SMS_TASK_ARCHIVE_STATUS,
    payload: { taskId, archived }
  };
};

/*
 * Archive an SMS task (text thread)
 */
export const archiveSmsTask = (taskId, messageId) => {
  return function(dispatch, getState) {
    dispatch(updateSmsTaskArchiveStatus(taskId, true));
    
    // Make API call in background
    ServiceApi.archiveSmsTask(() => {
    }, (error, status, content) => {
      dispatch(updateSmsTaskArchiveStatus(taskId, false));
      PortalApi.defaultErrorHandler(error, status, content);
    }, messageId);
  }
}

/*
 * Unarchive an SMS task (text thread)
 */
export const unarchiveSmsTask = (taskId, messageId) => {
  return function(dispatch, getState) {
    dispatch(updateSmsTaskArchiveStatus(taskId, false));
    
    // Make API call in background
    ServiceApi.unarchiveSmsTask(() => {
    }, (error, status, content) => {
      dispatch(updateSmsTaskArchiveStatus(taskId, true));
      PortalApi.defaultErrorHandler(error, status, content);
    }, messageId);
  }
}

/*
 * Mark chats as read
 */
export const bulkMarkMessageRead = (messageIds, chatIds) => {
  return function(dispatch, getState) {
    ServiceApi.bulkReadMessage(() => {
      dispatch(getAllMessages({ force:true }))
    }, null, messageIds, chatIds);
  }
}

/*
 * Unmark a message read for the current user
 */
export const unmarkMessageRead = (messageId) => {
  return function(dispatch, getState) {
    localUpdate(dispatch, getState, messageId, message => ({...message, read : undefined}));
    ServiceApi.unreadMessage(() => {
      // dispatch(updateMessages());
      dispatch(getAllMessages({ force: true }));
    }, null, messageId);
  }
}

/*
 * Unmark bulk message read for the current user
 */
export const bulkUnmarkMessageRead = (messageIds, chatIds) => {
  return function(dispatch, getState) {
    ServiceApi.bulkUnreadMessage(() => {
      dispatch(getAllMessages({ force:true }))
    }, null, messageIds, chatIds);
  }
}

/*
 * Mark a message as archived for the current user
 */
export const archiveMessage = (messageId) => {
  return function(dispatch, getState) {
    let date = new Date();
    localUpdate(dispatch, getState, messageId, message => ({...message, archived : date}));
    ServiceApi.archiveMessage(() => {
      // dispatch(updateMessages());
      dispatch(getAllMessages({ force: true }));
    }, null, messageId);
  }
}

export const bulkArchiveMessage = (messageIds, chatIds) => {
  return function(dispatch, getState) {
    ServiceApi.bulkArchiveMessage(() => {
      dispatch(getAllMessages({ force:true }))
    }, null, messageIds, chatIds);
  }
}

/*
 * Unarchive a message for the current user
 */
export const unarchiveMessage = (messageId) => {
  return function(dispatch, getState) {
    localUpdate(dispatch, getState, messageId, message => ({...message, archived : undefined}));
    ServiceApi.unarchiveMessage(() => {
      // dispatch(updateMessages());
      dispatch(getAllMessages({ force: true }));
    }, null, messageId);
  }
}

export const bulkUnarchiveMessage = (messageIds, chatIds) => {
  return function(dispatch, getState) {
    ServiceApi.bulkUnarchiveMessage(() => {
      dispatch(getAllMessages({ force:true }))
    }, null, messageIds, chatIds);
  }
}


/*
 * Toggle the followup flag on a message
 */
export const toggleFollowup = (message, dashboard) => {
  return function(dispatch, getState) {
    localUpdate(dispatch, getState, message.messageId, message =>
      ({...message, followup: message.followup === 'Y' || message.messageFollowup === 'Y' ? 'N' : 'Y'}));
    ServiceApi.changeFollowup(() => {
      // if(dashboard){dispatch(getAllMessages())}
      // else {dispatch(updateMessages());}
      dispatch(getAllMessages({ force:true }))
    }, null, message.messageId, message.followup === 'Y' || message.messageFollowup === 'Y' ? 'N' : 'Y');
  }
}

export const toggleBulkFollowup = (messageIds, chatIds, dashboard, followUp) => {
  return function(dispatch, getState) {
    ServiceApi.changeBulkFollowup(() => {
      // if(dashboard){dispatch(getAllMessages())}
      // else {dispatch(updateMessages());}
      dispatch(getAllMessages({ force:true }))
    }, null, messageIds, chatIds, followUp);
  }
}

/*
 * Toggle the hold calls flag
 */
export const toggleHoldCalls = () => {
  return function(dispatch, getState) {
    /* Prevent multiple clicks while the last one is still pending */
    if (serviceSelectors.getUpdatingHoldCalls(getState())) {
      return;
    }
    let user = coreSelectors.getUser(getState());
    let holdCalls = user.holdCalls === 'Y' ? 'N' : 'Y';
    /* This is cleared when updateUser completes */
    dispatch(setUpdatingHoldCalls(true));
    dispatch(coreActions.setUser({...user, holdCalls}));
    ServiceApi.changeHoldCalls(() => {
      dispatch(coreActions.updateUser());
    }, null, holdCalls);
    
  }
}

/*
 * Get the selection lists used during status setup
 */
export const updateStatusSelectionLists = () => {
  return function(dispatch, getState) {
    ServiceApi.queryStatusLists((statusSelectionLists) => {
      dispatch(setStatusSelectionLists(statusSelectionLists));
    });
      
  }
}

function calculateTimePeriod(startTime, endTime, durationCode) {
  if(typeof(startTime) === 'string'){startTime = new Date(startTime)}
  if(typeof(endTime) === 'string'){endTime = new Date(endTime)}
  let period = { startTime, endTime };
  if (period.startTime === null) {
    period.startTime = new Date();
  }
  if(durationCode === 'NOEND'){
    period.endTime = null;
  }
  if (durationCode !== 'CUSTOM' && durationCode !== 'NOEND') {
    period.endTime = new Date(period.startTime.getTime());
    if (durationCode === '15MIN') {
      period.endTime.setMinutes(period.endTime.getMinutes()+15);
    }
    if (durationCode === '1HOUR') {
      period.endTime.setHours(period.endTime.getHours()+1);
    }
    if (durationCode === '2HOUR') {
      period.endTime.setHours(period.endTime.getHours()+2);
    }
    if (durationCode === '3HOUR') {
      period.endTime.setHours(period.endTime.getHours()+3);
    }
    if (durationCode === 'DAY') {
      period.endTime.setHours(24,0,0,0);
    }
    if (durationCode === 'WEEK') {
      /* Day of week is 0-6 with 0 being Sunday.  We want Friday 
         midnight in their timezone */
      let dow = period.endTime.getDay();
      if (dow<6) {
        period.endTime.setHours(24+24*(5-dow),0,0,0);
      } else {
        period.endTime.setHours(24*7,0,0,0);
      }
    }
  }
  return(period);
}

/*
 * Add and schedule a status.  If override if false and there is a
 *  conflict, call the conflict function.
 */
export const addStatus = (status, override, schedule, conflict) => {
  return function(dispatch, getState) {
    if (schedule) {
      dispatch(coreActions.openBusy('Scheduling Status...'));
    } else {
      dispatch(coreActions.openBusy('Saving Status...'));
    }
    let statusSelectionLists =
      serviceSelectors.getStatusSelectionLists(getState());
    let newStatus = {...status};

    if (!Boolean(newStatus.statusName)) {
      newStatus.statusName = 'Unnamed Status';
    }

    /* Get the key values from the codes */
    if (!newStatus.messageStatusListId && status.messageCode) {
      newStatus.messageStatusListId =
        statusSelectionLists.messages
                            .find(item => (item.code === status.messageCode)).statusListId;
    }
    if (!newStatus.instructionStatusListId && status.instructionCode) {
      newStatus.instructionStatusListId =
        statusSelectionLists.instructions
                            .find(item => (item.code === status.instructionCode)).statusListId;
    }
    if (!newStatus.durationStatusListId && status.durationCode) {
      newStatus.durationStatusListId =
        statusSelectionLists.durations
                            .find(item => (item.code === status.durationCode)).statusListId;
    }

    /* Figure out the time period if scheduling */
    if (schedule) {
      let period = calculateTimePeriod(newStatus.startTime,
                                       newStatus.endTime,
                                       newStatus.durationCode);
      newStatus.startTime = period.startTime;
      newStatus.endTime = period.endTime;
    } else {
      newStatus.startTime = null;
      newStatus.endTime = null;
    }
    if(new Date(newStatus.endTime).getTime() < new Date(newStatus.startTime).getTime() && newStatus.endTime !== null){
      coreActions.postSnackMessage('error', 'The end time must be after the start time.');
      return;
    }

    /* Try the add */
    ServiceApi.addStatus((response) => {
      dispatch(coreActions.updateUser(() => {
        dispatch(coreActions.closeBusy());
      }));
    }, (error, status, content) => {
      /* 409 means schedule conflict so bring up the override dialog */
      if (status === 409) {
        dispatch(coreActions.closeBusy());      
        conflict(error);
      } else {
        PortalApi.defaultErrorHandler(error, status, content);
      }
    }, newStatus, override);
  }
}

/*
 * Update an existing status.  
 */
export const updateStatus = (status, schedule, override, scheduleId, conflict, completed) => {
  return function(dispatch, getState) {
    dispatch(coreActions.openBusy('Updating Status...'));        
    let statusSelectionLists =
      serviceSelectors.getStatusSelectionLists(getState());
    let newStatus = {...status};
    newStatus.scheduleId = scheduleId;
    if (!Boolean(newStatus.statusName)) {
      newStatus.statusName = 'Unnamed Status';
    }

    /* Get the key values from the codes */
    if (!newStatus.messageStatusListId && status.messageCode) {
      newStatus.messageStatusListId =
        statusSelectionLists.messages
                            .find(item => (item.code === status.messageCode)).statusListId;
    }
    if (!newStatus.instructionStatusListId && status.instructionCode) {
      newStatus.instructionStatusListId =
        statusSelectionLists.instructions
                            .find(item => (item.code === status.instructionCode)).statusListId;
    }
    if (!newStatus.durationStatusListId && status.durationCode) {
      newStatus.durationStatusListId =
        statusSelectionLists.durations
                            .find(item => (item.code === status.durationCode)).statusListId;
    }

    /* Figure out the time period if scheduling */
    if (schedule) {
      let period = calculateTimePeriod(newStatus.startTime,
                                       newStatus.endTime,
                                       newStatus.durationCode);
      newStatus.startTime = period.startTime;
      newStatus.endTime = period.endTime;
    } else {
      newStatus.startTime = null;
      newStatus.endTime = null;
    }
    if(new Date(newStatus.endTime).getTime() < new Date(newStatus.startTime).getTime() && newStatus.endTime !== null){
      dispatch(coreActions.postSnackMessage('error', 'The end time must be after the start time.'));
      dispatch(coreActions.closeBusy());
      return;
    }

    ServiceApi.updateStatus((response) => {
      dispatch(coreActions.updateUser(() => {
        if(typeof(completed) === 'function'){
          completed();
        }
        dispatch(coreActions.closeBusy());
      }));
    }, (error, status, content) => {
      /* 409 means schedule conflict so bring up the override dialog */
      if (status === 409) {
        dispatch(coreActions.closeBusy());      
        conflict(error);
      } else {
        PortalApi.defaultErrorHandler(error, status, content);
      }
    }, newStatus, override);
  }
}

/* Schedule a saved status calling the conflict method with an error message
   if override is false and there is a conflict  */
export const scheduleStatus = (status, override, conflict) => {
  return function(dispatch, getState) {
    dispatch(coreActions.openBusy('Scheduling Status...'));        
    /* Calculate the time period */
    let period = calculateTimePeriod(status.startTime,
                                     status.endTime,
                                     status.durationCode);
    /* Try the add */
    ServiceApi.scheduleStatus((response) => {
      dispatch(coreActions.updateUser(() => {
        dispatch(coreActions.closeBusy());
      }));
    }, (error, status, content) => {
      /* 409 means schedule conflict so bring up the override dialog */
      if (status === 409) {
        dispatch(coreActions.closeBusy());      
        conflict(error);
      } else {
        PortalApi.defaultErrorHandler(error, status, content);
      }
    }, status.statusId, period.startTime, period.endTime, override);
  }
}


/* Add a scheduled but unsaved status to the save list */
export const saveStatus = (statusId) => {
  return function(dispatch, getState) {
    dispatch(coreActions.openBusy('Saving Status...'));    
    ServiceApi.saveStatus((response) => {
      dispatch(coreActions.updateUser(() => {
        dispatch(coreActions.closeBusy());
      }));
    }, null, statusId);
  }
}

/* Remove a saved status */
export const removeStatus = (statusId) => {
  return function(dispatch, getState) {
    dispatch(coreActions.openBusy('Removing Status...'));    
    ServiceApi.removeStatus((response) => {
      dispatch(coreActions.updateUser(() => {
        dispatch(coreActions.closeBusy());
      }));
    }, null, statusId);
  }
}

/* Cancel a status schedule */
export const cancelStatus = (statusId, statusScheduleId) => {
  return function(dispatch, getState) {
    dispatch(coreActions.openBusy('Canceling Status...'));
    ServiceApi.cancelStatus((response) => {
      dispatch(coreActions.updateUser(() => {
        dispatch(coreActions.closeBusy());
      }));
    }, null, statusId, statusScheduleId);
  }
}

/* */
export const setFilterLocations = (filterLocations) => ({
  type : actionTypes.SET_FILTER_LOCATIONS,
  payload : { filterLocations }
});

/* */
export const setMessage = (message) => ({
  type : actionTypes.SET_MESSAGE,
  payload : { message }
});

/* */
export const setActivityDetailOpen = (activityDetailOpen) => ({
  type : actionTypes.SET_ACTIVITY_DETAIL_OPEN,
  payload : { activityDetailOpen }
});

/* */
export const setContact = (contact) => ({
  type : actionTypes.SET_CONTACT,
  payload : { contact }
});

/* */
export const setContactOpen = (contactOpen) => ({
  type : actionTypes.SET_CONTACT_OPEN,
  payload : { contactOpen }
});

/* */
export const setContactChanged = (contactChanged) => ({
  type : actionTypes.SET_CONTACT_CHANGED,
  payload : { contactChanged }
});

/* */
export const setActivityViewType = (activityViewType) => ({
  type : actionTypes.SET_ACTIVITY_VIEW_TYPE,
  payload : { activityViewType }
});

/* */
export const setContactsSearchText = (contactsSearchText) => ({
  type : actionTypes.SET_CONTACTS_SEARCH_TEXT,
  payload : { contactsSearchText }
});


/* */
export const setUpdatingHoldCalls = (updatingHoldCalls) => ({
  type : actionTypes.SET_UPDATING_HOLD_CALLS,
  payload : { updatingHoldCalls }
});

/* */
export const setUpdatingMessages = (updatingMessages) => ({
  type : actionTypes.SET_UPDATING_MESSAGES,
  payload : { updatingMessages }
});

/* */
export const setUpdateMessagesAgain = (updateMessagesAgain) => ({
  type : actionTypes.SET_UPDATE_MESSAGES_AGAIN,
  payload : { updateMessagesAgain }
});

/* */
export const setStatusSelectionLists = (statusSelectionLists) => ({
  type : actionTypes.SET_STATUS_SELECTION_LISTS,
  payload : { statusSelectionLists }
});

/* */
export const setStatus = (status) => ({
  type : actionTypes.SET_STATUS,
  payload : { status }
});

/* */
export const setStatusOpen = (statusOpen) => ({
  type : actionTypes.SET_STATUS_OPEN,
  payload : { statusOpen }
});

/* */
export const setSmsTask = (smsTask) => ({
  type : actionTypes.SET_SMS_TASK,
  payload : { smsTask }
});


export const openSendText = (destinationPhoneNumber) => {
  return function(dispatch, getState) {
    let user = coreSelectors.getUser(getState());
    let sourcePhoneNumberId = serviceSelectors.getSourcePhoneNumberId(getState());
    let patchNumbers = user.patchNumbers || [];
    
    /* Get the saved value if not set and verify it is still usable */
    if (!sourcePhoneNumberId && localStorage.getItem("phoneNumberId")) {
      sourcePhoneNumberId = localStorage.getItem("phoneNumberId");
      let number = patchNumbers.find(number => number.phoneNumberId === sourcePhoneNumberId);
      if (!number) {
        localStorage.removeItem('phoneNumberId');
        sourcePhoneNumberId = '';
      }
    }

    /* Verify the current setting is usable */
    if (sourcePhoneNumberId) {
      let number = patchNumbers.find(number => number.phoneNumberId === sourcePhoneNumberId);
      if (!number) {
        sourcePhoneNumberId = '';
      }
    }

    /* Use the first one in the list if still not set */
    if (!sourcePhoneNumberId && patchNumbers.length > 0) {
      sourcePhoneNumberId = patchNumbers[0].phoneNumberId;
    }
    
    dispatch(setSourcePhoneNumberId(sourcePhoneNumberId));
    dispatch(setTextPhoneNumber(destinationPhoneNumber));
    dispatch(setSendTextOpen(true));
  }
}

/* Send a text mesage */
export const sendText = (
  sourcePhoneNumberId,
  destinationPhoneNumber,
  message,
  success
) => {
  return function (dispatch, getState) {
    dispatch(setSendingText(true));
    ServiceApi.sendText(
      (response) => {
        // dispatch(setSendingText(false));
        dispatch(
          querySmsTasks({
            success: ()=>{
              dispatch(setSendingText(false));      
            },
            fail: ()=>{
              dispatch(setSendingText(false));
            }
          })
        );
        if (typeof success === "function") {
          success();
        }
      },
      (error, status, content) => {
        PortalApi.defaultErrorHandler(error, status, content);
        dispatch(setSendingText(false));
      },
      sourcePhoneNumberId,
      destinationPhoneNumber,
      message
    );
  };
};

/* */
export const setUpdatingSmsTasks = (updatingSmsTasks) => ({
  type : actionTypes.SET_UPDATING_SMS_TASKS,
  payload : { updatingSmsTasks }
});

/* */
export const setBackgroundUpdatingSmsTasks = (backgroundUpdatingSmsTasks) => ({
  type : actionTypes.SET_BACKGROUND_UPDATE_SMS_TASKS,
  payload : { backgroundUpdatingSmsTasks }
});

/* */
export const setUpdateSmsTasksAgain = (updateSmsTasksAgain) => ({
  type : actionTypes.SET_UPDATE_SMS_TASKS_AGAIN,
  payload : { updateSmsTasksAgain }
});

/* */
export const setTransferServices = (transferServices) => ({
  type : actionTypes.SET_TRANSFER_SERVICES,
  payload : { transferServices }
});

/* Update the list of available transfer services */
export const updateTransferServices = () => {
  return function(dispatch, getState) {
    ServiceApi.queryTransferServices((response) => {
      dispatch(setTransferServices(response.transferServices));
    });
  }
}

/* Create a new transfer service link and redirect for authorization.  CLIOGROW does not redirect */
export const createTransferLink = (transferServiceId, token,apiKey) => {
  return function(dispatch, getState) {
    ServiceApi.createTransferLink((response) => {
      if(response.transferKey === "CLIOGROW"  || response.transferKey === "EMAIL"  || response.transferKey === "TWILIO" || response.transferKey === "INFLUXMD") {
        dispatch(coreActions.updateUser());
        dispatch(enableAutomaticTransfers(response.transferLinkId))
      } else {
        window.location.href = PortalApi.BaseUrl() +
                               '/transferauth?transferLinkId=' + response.transferLinkId;        
      }
    }, undefined, transferServiceId, token,apiKey);
  }
}

/* Navigate to the authorization page on an existing link */
export const refreshTransferLink = (transferLink, token,apiKey) => {
  return function(dispatch, getState) {
    if (transferLink.transferKey === "CLIOGROW" || transferLink.transferKey === "EMAIL" || transferLink.transferKey === "TWILIO" || transferLink.transferKey === "INFLUXMD") {
      ServiceApi.updateTransferLink((response) => {
        dispatch(coreActions.updateUser());
      }, undefined, transferLink.transferLinkId, token,apiKey);
    } else {
      window.location.href = PortalApi.BaseUrl() +
                             '/transferauth?transferLinkId=' + transferLink.transferLinkId;
    }
  }
}

/* Delete a transfer link */
export const deleteTransferLink = (transferLinkId) => {
  return function(dispatch, getState) {
    ServiceApi.deleteTransferLink((response) => {
      dispatch(coreActions.updateUser());      
    }, undefined, transferLinkId);
  }
}

/* Enable automatic transfers */
export const enableAutomaticTransfers = (transferLinkId) => {
  return function(dispatch, getState) {
    ServiceApi.createTransferLinkRule((response) => {
      dispatch(coreActions.updateUser());      
    }, undefined, transferLinkId, 'Y', 'N');
  }
}

/* add custom transfer rules */
export const addNewCustomTransferRule = (transferLinkId,deny,ruleOption,ruleValue) => {
  var accountId,phoneNumberId, messageGroupId;
  if(ruleOption ==='accountId'){
    accountId = ruleValue;
  }else if(ruleOption === 'messageGroupId'){
    messageGroupId = ruleValue;
  }else{
    phoneNumberId = ruleValue;
  }
  return function(dispatch, getState) {
    ServiceApi.createTransferLinkRule((response) => {
      dispatch(coreActions.updateUser());      
    }, undefined, transferLinkId, 'N', deny,accountId,phoneNumberId, undefined, messageGroupId);
  }
}


/* delete custom transfer rules */
export const deleteCustomTransferRule = (transferLinkId,transferRuleId) => {
  return function(dispatch, getState) {
    ServiceApi.deleteTransferLinkRule((response) => {
      dispatch(coreActions.updateUser());      
    }, undefined, transferLinkId,transferRuleId);
  }
}


/* Disable automatic transfers */
export const disableAutomaticTransfers = (transferLinkId) => {
  return function(dispatch, getState) {
    ServiceApi.deleteAllTransferLinkRules((response) => {
      dispatch(coreActions.updateUser());
    }, undefined, transferLinkId);
  }
}



/* send verification code to email */
export const sendVerificationCode = (email,phone,code) => {
  return function(dispatch, getState) {
    ServiceApi.sendVerificationCodeEmail((response) => {  
    }, undefined, email,phone,code);
  }
}

/* */
export const setMessages = (messages) => ({
  type : actionTypes.SET_MESSAGES,
  payload : { messages }
});

/* */
export const setContactLink = (contactLink) => ({
  type : actionTypes.SET_CONTACT_LINK,
  payload : { contactLink }
});

/* */
export const setContactLinkOpen = (contactLinkOpen) => ({
  type : actionTypes.SET_CONTACT_LINK_OPEN,
  payload : { contactLinkOpen }
});

/* */
export const setContactLinkContacts = (contactLinkContacts) => ({
  type : actionTypes.SET_CONTACT_LINK_CONTACTS,
  payload : { contactLinkContacts }
});

export const openContactLink = (contactLink, anchor) => {
  return function(dispatch, getState) {
    const contacts = coreSelectors.getUser(getState()).contacts;
    if (contactLink.type === 'EMAIL') {
      let searchText = contactLink.value.toUpperCase();
      dispatch(setContactLinkContacts(contacts.filter(contact => {
        let emailMatches = contact.contactMethods.filter(method =>
          method.email && method.email.toUpperCase().includes(searchText)).length;
        return(emailMatches > 0);
      })));
    }
    if (contactLink.type === 'PHONE') {
      let phoneSearch = contactLink.value.replace(/[()-\s]/g, '');
      dispatch(setContactLinkContacts(contacts.filter(contact => {
        let numberMatches = contact.contactMethods.filter(method =>
          method.phoneNumber && method.phoneNumber.replace(/[()-\s]/g, '')
                                      .includes(phoneSearch)).length;
        return(numberMatches > 0);
      })));
    }
    dispatch(setContactLink(contactLink));
    dispatch(setContactLinkMenuAnchor(anchor));
    dispatch(setContactLinkOpen(true));
  }
}


/* */
export const setAssistOpen = (assistOpen) => ({
  type : actionTypes.SET_ASSIST_OPEN,
  payload : { assistOpen }
});

export const openAssist = (task) => {
  return function(dispatch, getState) {
    dispatch(setAssistOpen(true));
    if (task) {
      dispatch(setAssistTask(task));
    }
  }
}

export const submitAssist = (locationId, requestType, referenceTaskId, referenceMessageId,
                             outboundPhoneNumberId, request, success, fail) => {
  return function(dispatch, getState) {
    ServiceApi.submitAssistRequest(() => {
      if (typeof(success) === 'function') {
        success();
      }
    }, () => {
      if (typeof(fail) === 'function') {
        fail();
      }
    }, locationId, requestType, referenceTaskId, referenceMessageId, outboundPhoneNumberId, request);
  }
                             }

export const manualTransfer = (transferLinkId, deliveryId) => {
  return function(dispatch, getState) {
    ServiceApi.manualTransfer(() => {
      dispatch(coreActions.postSnackMessage('success', 'Transfer', 'The activity was successfully queued for transfer.'));
      dispatch(coreActions.updateUser());
    }, undefined, transferLinkId, deliveryId);
  }
}

export const backfillTransferLink = (transferLinkId) => {
  return function(dispatch, getState) {
    ServiceApi.backfillTransferLink((result) => {
      dispatch(coreActions.postSnackMessage('success', 'Back Fill',
                                            'Activities queued for transfer: ' + result.deliveriesQueued));
      dispatch(coreActions.updateUser());
    }, undefined, transferLinkId);
  }
}


/* */
export const setContactLinkMenuAnchor = (contactLinkMenuAnchor) => ({
  type : actionTypes.SET_CONTACT_LINK_MENU_ANCHOR,
  payload : { contactLinkMenuAnchor }
});

/* */
export const setAddContactLink = (addContactLink) => ({
  type : actionTypes.SET_ADD_CONTACT_LINK,
  payload : { addContactLink }
});

/* */
export const setAssistTask = (assistTask) => ({
  type : actionTypes.SET_ASSIST_TASK,
  payload : { assistTask }
});

/* */
export const setSendTextOpen = (sendTextOpen) => ({
  type : actionTypes.SET_SEND_TEXT_OPEN,
  payload : { sendTextOpen }
});

/* */
export const setSourcePhoneNumberId = (sourcePhoneNumberId) => ({
  type : actionTypes.SET_SOURCE_PHONE_NUMBER_ID,
  payload : { sourcePhoneNumberId }
});

/* */
export const setTextPhoneNumber = (textPhoneNumber) => ({
  type : actionTypes.SET_TEXT_PHONE_NUMBER,
  payload : { textPhoneNumber }
});

/* */
export const setSendingText = (sendingText) => ({
  type : actionTypes.SET_SENDING_TEXT,
  payload : { sendingText }
});

/* */
export const setTextSearch = (textSearch) => ({
  type : actionTypes.SET_TEXT_SEARCH,
  payload : { textSearch }
});

/* */
export const setBlockNumbersAccount = (blockNumbersAccount) => ({
  type : actionTypes.SET_BLOCK_NUMBERS_ACCOUNT,
  payload : { blockNumbersAccount }
});

export const setUnblockNumberState = ({
  confirmUnblockNumber,
  unblockPhoneNumber,
  unblockAccountId,
}) => ({
  type: actionTypes.SET_UNBLOCK_NUMBER_STATE,
  payload: {
    confirmUnblockNumber,
    unblockPhoneNumber,
    unblockAccountId,
  },
});

/* */
export const setUnreadMessageCount = (unreadMessageCount) => ({
  type : actionTypes.SET_UNREAD_MESSAGE_COUNT,
  payload : { unreadMessageCount }
});

/* */
export const setUnreadChatCount = (unreadChatCount) => ({
  type : actionTypes.SET_UNREAD_CHAT_COUNT,
  payload : { unreadChatCount }
});

export const setPdfContent = (pdfContent) => ({
  type : actionTypes.SET_PDF_DATA,
  payload : { pdfContent: pdfContent }
});

/*
 * block a phone number 
 */
export const blockNumbersByAccount = (accountId,completed) => {
  return function(dispatch, getState) {
    ServiceApi.getBlockedNumbersByAccount((result) =>{
      dispatch(setBlockNumbersAccount(result))
      if (typeof(completed) === 'function') {
        completed();
      }
    }, (error) => {
      if (typeof(completed) === 'function') {
        completed();
      }      
    }, accountId);
  }
}

/*
 * block a phone number 
 */
export const blockPhoneNumber = (accountId, phoneNumber,name=undefined, company=undefined,completed=undefined) => {
  return function(dispatch, getState) {
    ServiceApi.blockPhoneNumber(() =>{
        dispatch(coreActions.postSnackMessage('success', 'Blocked successfully.'))
        dispatch(blockNumbersByAccount(accountId));
      if (typeof(completed) === 'function') {
        completed();
      }
    }, (error) => {
      if (typeof(completed) === 'function') {
        completed();
      }      
    }, accountId, phoneNumber,name, company);
  }
}
/**
 * Edit a blocked number
 */
export const editBlockPhoneNumber = ({
  accountId,
  entryId,
  name,
  company,
  phoneNumber,
  completed,
}) => {
  return function (dispatch, getState) {
    ServiceApi.editBlockPhoneNumber(
      () => {
        dispatch(
          coreActions.postSnackMessage("success", "Updated successfully.")
        );
        dispatch(blockNumbersByAccount(accountId));
        if (typeof completed === "function") {
          completed();
        }
      },
      (error) => {
        if (typeof completed === "function") {
          completed();
        }
      },
      accountId,
      phoneNumber,
      entryId,
      name,
      company
    );
  };
};
/*
 * unblock a phone number 
 */
export const unblockPhoneNumber = (accountId, existingNumber, completed) => {
  return function (dispatch, getState) {
    const { confirmUnblockNumber, unblockAccountId, unblockPhoneNumber } =
      serviceSelectors.getUnblockNumberState(getState());
    if (!confirmUnblockNumber) {
      dispatch(
        setUnblockNumberState({
          confirmUnblockNumber: true,
          unblockAccountId: accountId,
          unblockPhoneNumber: existingNumber,
        })
      );
    } else if(confirmUnblockNumber && unblockAccountId && unblockPhoneNumber) {
      ServiceApi.unblockPhoneNumber(
        () => {
          dispatch(
            setUnblockNumberState({
              confirmUnblockNumber: false,
              unblockAccountId: null,
              unblockPhoneNumber: null,
            })
          );
          dispatch(
            coreActions.postSnackMessage("success", "Unblocked successfully.")
          );
          dispatch(blockNumbersByAccount(unblockAccountId));
          if (typeof completed === "function") {
            completed();
          }
        },
        (error) => {
          if (typeof completed === "function") {
            completed();
          }
        },
        unblockAccountId,
        unblockPhoneNumber
      );
    }
  };
};

/*
 * Create Conditional call forwarding
 */
export const createConditionalCallForwarding = (phoneNumberId, patchNumber, handling, forwardToAgent, update, completed, error) => {
  return function(dispatch, getState) {
    ServiceApi.createConditionalCallForwarding(() => {
      if(update && handling === 'FORWARD'){
        dispatch(coreActions.postSnackMessage('success', 'Updated call forwarding'));
      }else if(handling === 'FORWARD'){
        dispatch(coreActions.postSnackMessage('success', 'Enabled call forwarding'));
      } else {
        dispatch(coreActions.postSnackMessage('success', 'Disabled call forwarding'));
      }
      dispatch(accountActions.queryAccount());
      if(typeof(completed) === 'function'){
        completed();
      }
    }, (statusText,status,content) => {
      dispatch(coreActions.postSnackMessage('error', 'An error occured'));
      if(typeof(error) === 'function'){
        error(statusText,status,content)
      }
    }, phoneNumberId, patchNumber, handling, forwardToAgent);
  }
}

export const markPurechatRead = (chatId, clear) => {
  return function(dispatch, getState) {
    ServiceApi.markChatRead(() => {
      dispatch(getAllMessages({ force: true }));
    }, null, chatId, clear);
  }
}

export const markPurechatArchived = (chatId, clear) => {
  return function(dispatch, getState) {
    ServiceApi.markChatArchived(() => {
      dispatch(getAllMessages({ force: true }));
    }, null ,chatId, clear);
  }
}

export const markPurechatFollowup = (chatId, followup) => {
  return function(dispatch, getState) {
    ServiceApi.markChatFollowup(() => {
      dispatch(getAllMessages({ force: true }));
    }, null ,chatId, followup);
  }
}

export const importContacts = (transferLinkId) => {
  return function(dispatch, getState) {
    ServiceApi.importContacts(() => {
      dispatch(coreActions.postSnackMessage('success', 'Imported contacts successfully'))
    }, null, transferLinkId);
  }
}

export const getVipCallersByAccount = (accountId,completed) => {
  return function(dispatch, getState) {
    ServiceApi.getVipCallersByAccount((result) =>{
      dispatch(setVipCallers(result))
      if (typeof(completed) === 'function') {
        completed();
      }
    }, (error) => {
      if (typeof(completed) === 'function') {
        completed();
      }      
    }, accountId);
  }
}

export const setVipCallers = (vipCallers) => ({
  type : actionTypes.SET_VIP_CALLERS,
  payload : { vipCallers }
});

export const createVipContact = (accountId, name, company, phoneNumber) => {
  return function (dispatch, getState) {
    ServiceApi.createVipContact(() => {
      dispatch(getVipCallersByAccount(accountId));
    }, null, accountId, name, company, phoneNumber);
  }
}

export const updateVipContact = (vipCallerId, accountId, name, company, phoneNumber) => {
  return function (dispatch, getState) {
    ServiceApi.updateVipContact(() => {
      dispatch(getVipCallersByAccount(accountId));
    }, null, accountId, name, company, phoneNumber, vipCallerId);
  }
}

export const deleteVipContact = (accountId, vipCallerId) => {
  return function (dispatch, getState) {
    ServiceApi.deleteVipContact(() => {
      dispatch(getVipCallersByAccount(accountId));
    }, null, vipCallerId);
  }
}

export const updateVipForwardingNumber = (accountId, vipForwardingNumber, completed) => {
  return function(dispatch, getState) {
    ServiceApi.updateVipForwardingNumber(() => {
      dispatch(coreActions.postSnackMessage('success', 'Updated VIP forwarding number'));
      if(typeof(completed) === 'function'){
        completed();
      }
      dispatch(accountActions.queryAccount());
    }, () => {
      console.log("There was an error");
    }, accountId, vipForwardingNumber);
  }
}

export const getReportFiles = (completed) => {
  return function (dispatch, getState) {
    ServiceApi.getReportFiles((result) => {
      dispatch(setReportFiles(result));
      if (typeof(completed) === 'function') {
        completed();
      }
    });
  }
}

export const getSignedUrl = (fileId, completed) => {
  return function (dispatch, getState) {
    ServiceApi.getSignedUrl(fileId, (result) => {
      if (typeof(completed) === 'function') {
        completed(result);
      }
    });
  }
}

export const setReportFiles = (reportFiles) => ({
  type : actionTypes.SET_REPORT_FILES,
  payload : { reportFiles }
});

export const setPureChatStartTime = (pureChatStartTime) => ({
  type : actionTypes.SET_PURE_CHAT_START_TIME,
  payload : { pureChatStartTime }
});

export const setPureChatEndTime = (pureChatEndTime) => ({
  type : actionTypes.SET_PURE_CHAT_END_TIME,
  payload : { pureChatEndTime }
});

// Call Handling Actions
export const loadCallHandling = (accountId) => {
  return function (dispatch, getState) {
    ServiceApi.getCallHandling(accountId, 
      (result) => {
        dispatch(setCallHandlingData(result));
      },
      (error) => {
        dispatch(coreActions.postSnackMessage('error', 'Failed to load call handling data'));
      }
    );
  }
};

export const updateGreeting = (accountId, greeting) => {
  return function (dispatch, getState) {
    ServiceApi.updateGreeting(accountId, greeting,
      (result) => {
        dispatch(coreActions.postSnackMessage('success', 'Greeting updated successfully'));
        dispatch(loadCallHandling(accountId));
      },
      (error) => {
        dispatch(coreActions.postSnackMessage('error', 'Failed to update greeting'));
      }
    );
  }
};

export const updateKnowledgeBase = (accountId, knowledgeBase) => {
  return function (dispatch, getState) {
    ServiceApi.updateKnowledgeBase(accountId, knowledgeBase,
      (result) => {
        dispatch(coreActions.postSnackMessage('success', 'Knowledge Base updated successfully'));
        dispatch(loadCallHandling(accountId));
      },
      (error) => {
        dispatch(coreActions.postSnackMessage('error', 'Failed to update knowledge base'));
      }
    );
  }
};

export const updateFaq = (accountId, faq) => {
  return function (dispatch, getState) {
    ServiceApi.updateFaq(accountId, faq,
      (result) => {
        dispatch(coreActions.postSnackMessage('success', 'FAQ updated successfully'));
        dispatch(loadCallHandling(accountId));
      },
      (error) => {
        dispatch(coreActions.postSnackMessage('error', 'Failed to update FAQ'));
      }
    );
  }
};

export const updateBotDelay = (accountId, botDelay) => {
  return function (dispatch, getState) {
    ServiceApi.updateBotDelay(accountId, botDelay,
      (result) => {
        dispatch(coreActions.postSnackMessage('success', 'Bot delay updated successfully'));
        dispatch(loadCallHandling(accountId));
      },
      (error) => {
        dispatch(coreActions.postSnackMessage('error', 'Failed to update bot delay'));
      }
    );
  }
};

export const setCallHandlingData = (callHandlingData) => ({
  type: actionTypes.SET_CALL_HANDLING_DATA,
  payload: { callHandlingData }
});

export const loadPhoneNumbers = (accountId) => {
  return function (dispatch, getState) {
    ServiceApi.getPhoneNumbers(accountId, 
      (result) => {
        dispatch(setPhoneNumbers(result));
      },
      (error) => {
        dispatch(coreActions.postSnackMessage('error', 'Failed to load phone numbers'));
      }
    );
  }
};

export const setPhoneNumbers = (phoneNumbers) => ({
  type: actionTypes.SET_PHONE_NUMBERS,
  payload: { phoneNumbers }
});

export const allocatePhoneNumber = (accountId, areaCode) => {
  return function (dispatch, getState) {
    ServiceApi.allocatePhoneNumber(accountId, areaCode,
      (result) => {
        dispatch(coreActions.postSnackMessage('success', 'Phone number allocated successfully'));
        // Reload phone numbers to show the new number
        dispatch(loadPhoneNumbers(accountId));
      },
      (error) => {
        const errorMsg = error && error.error ? error.error : 'Failed to allocate phone number';
        dispatch(coreActions.postSnackMessage('error', errorMsg));
      }
    );
  }
};

/* Call Forms Actions */
export const setCallForm = (callForm) => ({
  type: actionTypes.SET_CALL_FORM,
  payload: { callForm }
});

export const setCallFormLoading = (loading) => ({
  type: actionTypes.SET_CALL_FORM_LOADING,
  payload: { loading }
});

export const loadCallForm = (accountId) => {
  return function (dispatch, getState) {
    dispatch(setCallFormLoading(true));
    ServiceApi.getCallForm(accountId,
      (result) => {
        dispatch(setCallForm(result));
        dispatch(setCallFormLoading(false));
      },
      (error) => {
        dispatch(coreActions.postSnackMessage('error', 'Failed to load call form'));
        dispatch(setCallFormLoading(false));
      }
    );
  };
};

/* AI Actions */
export const setAIActions = (aiActions) => ({
  type: actionTypes.SET_AI_ACTIONS,
  payload: { aiActions }
});

export const setAIActionsLoading = (loading) => ({
  type: actionTypes.SET_AI_ACTIONS_LOADING,
  payload: { loading }
});

export const setWarmTransferEnabled = (warmTransferEnabled) => ({
  type: actionTypes.SET_WARM_TRANSFER_ENABLED,
  payload: { warmTransferEnabled }
});

export const loadAIActions = (accountId) => {
  return function (dispatch, getState) {
    dispatch(setAIActionsLoading(true));
    ServiceApi.getAIActions(accountId,
      (result) => {
        dispatch(setAIActions(result.aiActions || []));
        dispatch(setWarmTransferEnabled(result.warmTransferEnabled || false));
        dispatch(setAIActionsLoading(false));
      },
      (error) => {
        dispatch(coreActions.postSnackMessage('error', 'Failed to load AI actions'));
        dispatch(setAIActionsLoading(false));
      }
    );
  };
};

export const createAIActionAsync = (aiAction) => {
  return function (dispatch, getState) {
    return new Promise((resolve, reject) => {
      ServiceApi.createAIAction(aiAction,
        (result) => {
          dispatch(coreActions.postSnackMessage('success', 'AI Action created successfully'));
          dispatch(loadAIActions(aiAction.accountId));
          resolve(result);
        },
        (error) => {
          dispatch(coreActions.postSnackMessage('error', 'Failed to create AI action'));
          reject(error);
        }
      );
    });
  };
};

export const updateAIActionAsync = (aiAction) => {
  return function (dispatch, getState) {
    return new Promise((resolve, reject) => {
      ServiceApi.updateAIAction(aiAction,
        (result) => {
          dispatch(coreActions.postSnackMessage('success', 'AI Action updated successfully'));
          dispatch(loadAIActions(aiAction.accountId));
          resolve(result);
        },
        (error) => {
          dispatch(coreActions.postSnackMessage('error', 'Failed to update AI action'));
          reject(error);
        }
      );
    });
  };
};

export const createFormVersionAsync = (sourceFormVersionId) => {
  return function (dispatch, getState) {
    return new Promise((resolve, reject) => {
      ServiceApi.createFormVersion(sourceFormVersionId,
        (result) => {
          dispatch(coreActions.postSnackMessage('success', 'Draft version created'));
          resolve(result);
        },
        (error) => {
          dispatch(coreActions.postSnackMessage('error', 'Failed to create draft version'));
          reject(error);
        }
      );
    });
  };
};

export const activateFormVersionAsync = (formId, formVersionId) => {
  return function (dispatch, getState) {
    return new Promise((resolve, reject) => {
      ServiceApi.activateFormVersion(formId, formVersionId,
        (result) => {
          dispatch(coreActions.postSnackMessage('success', 'Form version activated'));
          resolve(result);
        },
        (error) => {
          dispatch(coreActions.postSnackMessage('error', 'Failed to activate form version'));
          reject(error);
        }
      );
    });
  };
};

export const createFormFieldAsync = (field) => {
  return function (dispatch, getState) {
    return new Promise((resolve, reject) => {
      ServiceApi.createFormField(field,
        (result) => {
          dispatch(coreActions.postSnackMessage('success', 'Field added'));
          resolve(result);
        },
        (error) => {
          dispatch(coreActions.postSnackMessage('error', 'Failed to add field'));
          reject(error);
        }
      );
    });
  };
};

export const updateFormFieldAsync = (formFieldId, field) => {
  return function (dispatch, getState) {
    return new Promise((resolve, reject) => {
      ServiceApi.updateFormField(formFieldId, field,
        (result) => {
          resolve(result);
        },
        (error) => {
          dispatch(coreActions.postSnackMessage('error', 'Failed to update field'));
          reject(error);
        }
      );
    });
  };
};

export const updateManyFormFieldsAsync = (fields) => {
  return function (dispatch, getState) {
    return new Promise((resolve, reject) => {
      ServiceApi.updateManyFormFields(fields,
        (result) => {
          dispatch(coreActions.postSnackMessage('success', 'Fields saved'));
          resolve(result);
        },
        (error) => {
          dispatch(coreActions.postSnackMessage('error', 'Failed to save fields'));
          reject(error);
        }
      );
    });
  };
};

export const deleteFormFieldAsync = (formFieldId) => {
  return function (dispatch, getState) {
    return new Promise((resolve, reject) => {
      ServiceApi.deleteFormField(formFieldId,
        (result) => {
          dispatch(coreActions.postSnackMessage('success', 'Field deleted'));
          resolve(result);
        },
        (error) => {
          dispatch(coreActions.postSnackMessage('error', 'Failed to delete field'));
          reject(error);
        }
      );
    });
  };
};

export const moveFormFieldsAsync = (formFieldId, beforeFormFieldId) => {
  return function (dispatch, getState) {
    return new Promise((resolve, reject) => {
      ServiceApi.moveFormField(formFieldId, beforeFormFieldId,
        (result) => {
          resolve(result);
        },
        (error) => {
          dispatch(coreActions.postSnackMessage('error', 'Failed to reorder field'));
          reject(error);
        }
      );
    });
  };
};

export const toggleWarmTransferAsync = (accountId) => {
  return function (dispatch, getState) {
    return new Promise((resolve, reject) => {
      ServiceApi.toggleWarmTransfer(accountId,
        (result) => {
          dispatch(loadAIActions(accountId));
          resolve(result);
        },
        (error) => {
          dispatch(coreActions.postSnackMessage('error', 'Failed to toggle warm transfer'));
          reject(error);
        }
      );
    });
  };
};